import { PhoneNumberUtil } from 'google-libphonenumber';
import 'react-international-phone/style.css';

const phoneUtil = PhoneNumberUtil.getInstance();

const isPhoneValid = (phone: string) => {
    try {
        return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(phone));
    } catch (error) {
        return false;
    }
};

export const validatePhone = (phone: string | undefined) => {
    if (phone) {
        const isValid = isPhoneValid(phone);

        if (!isValid) {
            return 'Введите корректный номер телефона';
        }
    }

    return '';
};
